import { ClassNameValue, twMerge } from 'tailwind-merge';

export const cn = (...classes: ClassNameValue[]): string => {
  return twMerge(...classes);
};
